/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setOaName,
  setPublic,
  setActivityPublic,
  setType,
  setActivityType,
  getOas,
  getOaActivities,
  getActivitiesOptions,
  getActivitiesByTypeAndDate,
  setActivityDate,
  setDate,
  setActiveOa,

} from '../../actions';
import Close from '../../assets/cross-icon.svg';
import SelectedIcon from '../../assets/selected-icon.svg';

import './Filter.css';

const Filter = (props) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [filterSearched, setFilterSearched] = useState('');
  const [optionsSearched, setOptionsSearched] = useState(props.options);

  useEffect(() => {
    const inCheckboxes = props.label.filter((el) => el.value !== null);
    const settedCheckboxes = inCheckboxes.map((el) => el && ({ ...el, saved: true }));
    setCheckboxes(settedCheckboxes);
  }, [props.label]);


  let placeholder;

  if (props.type === 'public') {
    placeholder = 'PÚBLICO';
  } else {
    placeholder = 'ATIVIDADES';
  }

  const handleSearch = () => {
    // if (props.activity) {
    props.getActivitiesByTypeAndDate();
    // } else {
    props.getOas();
    props.history.push('/oa');
    // }
  };

  const handleClearFilters = () => {
    // if (props.activity) {
    //   props.setActivityType([]);
    //   props.setActivityPublic([]);
    //   props.setActivityDate(null, null);
    // } else {
    props.setPublic([]);
    props.setType([]);
    props.setOaName('');
    props.setDate(null, null);
    props.history.push('/oa');
    props.setActiveOa({
      seq_cadast: 0,
    });

    // Remove filtros das atividades
    props.setActivityType([]);
    props.setActivityPublic([]);
    props.setActivityDate(null, null);
    // }

    const emptyFilter = checkboxes.map((el) => ({
      ...el,
      checked: false,
      saved: false,
    }));

    setCheckboxes(emptyFilter);

    handleSearch();
  };

  const handleToggleDropdown = () => {
    setOptionsSearched(props.options);
    // handleClearFilters();
    setDropdownActive(!dropdownActive);
    if (dropdownActive === true) {
      handleSearch();
    }
  };

  const handleOptionClick = (option) => {
    const optionIndex = checkboxes.findIndex((el) => el.value === option.value);

    const optionElement = checkboxes[optionIndex] ? checkboxes[optionIndex] : null;

    const optionValue = {
      ...option,
      checked: optionElement ? optionElement.checked : true,
    };
    const newCheckboxes = [...checkboxes];
    if (optionIndex === -1) {
      newCheckboxes.push(optionValue);
    } else {
      newCheckboxes.splice(optionIndex, 1);
    }


    setCheckboxes(newCheckboxes);
  };

  const handleSave = () => {
    const newCheckboxesState = checkboxes.map((el) => ({
      ...el,
      checked: true,
      saved: true,
    }));

    setCheckboxes(newCheckboxesState);

    setDropdownActive(!dropdownActive);
    // if (props.activity) {
    if (props.type === 'public') {
      props.setActivityPublic(newCheckboxesState.map((el) => (el.saved ? el : '')));
    } else {
      props.setActivityType(newCheckboxesState.map((el) => (el.saved ? el : '')));
    }
    // } else {
    if (props.type === 'public') {
      props.setPublic(newCheckboxesState.map((el) => (el.saved ? el : '')));
    } else {
      props.setType(newCheckboxesState.map((el) => (el.saved ? el : '')));
    }
    // }


    handleToggleDropdown();
  };

  function handleSearchOptions(e) {
    setFilterSearched(e.target.value);
    const regex = new RegExp(e.target.value, 'i');

    const search = props.options.filter((el) => el.label.match(regex));
    setOptionsSearched(search);
  }

  if (props.type === 'clear') {
    return (
      <div className="filter-block">
        <div
          className="filter empty clear"
          role="presentation"
          onClick={handleClearFilters}
        >
          <p>LIMPAR FILTROS</p>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="filter-block">
        <div
          className={`filter ${checkboxes.length > 0 ? checkboxes.find((el) => el.saved === true) ? '' : 'empty' : 'empty'}`}
          onClick={handleToggleDropdown}
          role="presentation"
        >
          <div className="d-flex justify-content-center elipsis">
            {
                            checkboxes.length > 0 ? checkboxes.find(
                              (el) => el.saved === true,
                            )
                              ? (
                                <p>
                                  {props.type === 'public' ? 'PÚBLICO' : 'ATIVIDADES'}
                                  {' '}
                                        &#183;
                                  {' '}
                                  {checkboxes.length}
                                </p>
                              )
                              : <p>{placeholder}</p>

                              : <p>{placeholder}</p>
                        }
          </div>
        </div>
        <div className={`dropdown container ${dropdownActive ? 'active ' : ''}`}>
          <img src={Close} alt="Fechar" className="pt-4 close-icon pb-4" role="presentation" onClick={handleToggleDropdown} />
          <div className="options">
            {props.searchFilter
                            && (
                            <input
                              className="filterInput"
                              placeholder="Pesquisar"
                              onChange={(e) => handleSearchOptions(e)}
                              value={filterSearched}
                            />
                            )}
            {
                            optionsSearched && optionsSearched.map((option) => (
                              <div key={Math.random()}>
                                <div
                                  className={`option-block ${checkboxes.find((el) => {
                                    const elExists = el.value === option.value;
                                    const isActive = el.checked || el.saved;
                                    return elExists && isActive;
                                  }) ? 'active' : ''}`}
                                  onClick={() => handleOptionClick(option)}
                                  role="presentation"
                                >
                                  <p className="option-name">
                                    {option.label}
                                  </p>
                                  <img
                                    src={SelectedIcon}
                                    alt="Ativo"
                                  />
                                </div>
                                <hr />
                              </div>
                            ))
                        }

          </div>
          <div className="mt-auto text-center pb-3 mb-5 mb-sm-0">
            <button className="btn btn-primary big-button" type="button" onClick={handleSave}>Salvar</button>
          </div>
        </div>
      </div>
      <div className={dropdownActive ? 'backdrop' : ''} role="presentation" onClick={handleToggleDropdown} />
    </>
  );
};

const mapStateToProps = (store) => ({
  oaName: store.filterState.oaName,
  publicType: store.filterState.publicType,
  activityType: store.filterState.activityType,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  setOaName,
  setPublic,
  setActivityType,
  getOas,
  getOaActivities,
  getActivitiesOptions,
  getActivitiesByTypeAndDate,
  setActivityDate,
  setActiveOa,
  setType,
  setActivityPublic,
  setDate,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
